<template>
  <div class="second-layout">
    <div
      v-if="heroSection !== null"
      class="d-flex flex-column justify-center align-center hero-section-wrapper"
      :style="heroSectionBackground"
    >
      <v-container fluid style="z-index: 2">
        <v-row class="d-flex flex-column justify-center align-center">
          <v-col cols="12" sm="12" md="10" xl="6">
            <h1>{{ heroSection.title }}</h1>
            <h2>{{ heroSection.subtitle }}</h2>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <highlight-container
      v-if="jobVacancies && jobVacancies.length > 0"
      title="Vagas"
      even
      class="pa-0 py-10"
    >
      <v-row class="d-flex justify-center align-center pb-md-5">
        <v-col cols="12" sm="12" md="3" xl="3">
          <v-autocomplete
            :items="jobVacancies"
            item-text="title"
            no-data-text="Nenhuma vaga encontrada"
            label="Busque uma vaga"
            auto-select-first
            rounded
            solo
            hide-details="true"
            @change="goToVacancy"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="3" xl="3">
          <v-autocomplete
            :items="jobVacanciesTags"
            item-text="label"
            no-data-text="Nenhum termo encontrado"
            label="Selecione uma categoria"
            auto-select-first
            rounded
            solo
            clearable
            hide-details="true"
            @change="filterVacanciesList"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="d-flex flex-column justify-center align-center">
        <v-col cols="12" sm="12" md="10" xl="6">
          <ul class="job-vacancies-list-wrapper">
            <li v-for="(vacancy, i) in jobVacancies" :key="i">
              <router-link
                :to="{
                  name: 'vacancy',
                  params: {
                    slug: vacancy.title
                      .replace(/[^A-Z0-9]+/gi, '-')
                      .toLowerCase(),
                    data: {
                      description: vacancy.job_description,
                      subscription_link: pipefyLink,
                      vacancy_title: vacancy.title,
                      common_text: commonText,
                    },
                  },
                }"
              >
                {{ vacancy.title }}
                <v-chip
                  v-for="(tag, k) in vacancy.tags"
                  :key="k"
                  color="grey lighten-3"
                  class="my-2 mx-2"
                  >{{ tag.label }}</v-chip
                >
              </router-link>
            </li>
          </ul>
        </v-col>
      </v-row>
    </highlight-container>
    <highlight-container
      v-if="repeaterSections && repeaterSections.length > 0"
      even
      class="pa-0 py-10"
    >
      <v-row
        v-for="(section, i) in repeaterSections"
        :key="i"
        class="d-flex flex-column justify-center align-center mb-16"
        :style="[
          section.acf_fc_layout === 'slider_block'
            ? { 'background-color': '#f5f5f5' }
            : '',
        ]"
        :class="section.acf_fc_layout"
      >
        <!-- why_work_with_us -->
        <template v-if="section.acf_fc_layout === 'why_work_with_us'">
          <v-col cols="12" sm="12" md="10" xl="6">
            <h2 class="text-center title pa-0">
              {{ section.section_title }}
            </h2>
            <v-row class="ma-0" justify="center">
              <div class="separator" />
            </v-row>
            <p class="mb-10">{{ section.section_subtitle }}</p>
            <div class="row benefits-list-wrapper">
              <v-card
                v-for="(item, j) in section.items"
                :key="j"
                class="col-sm-12 col-md-4 col-xl-4 col-12"
              >
                <div class="item-content">
                  <v-avatar size="40" tile class="ma-4 mb-0">
                    <img :src="item.icon.url" :alt="item.icon.title" />
                  </v-avatar>
                  <v-card-title class="text-h5 mb-2">
                    {{ item.title }}
                  </v-card-title>
                  <v-divider class="mx-4"></v-divider>
                  <v-card-text>
                    <v-row align="center" class="mx-0">
                      <div class="my-4 text-subtitle-1">
                        {{ item.text }}
                      </div>
                    </v-row>
                  </v-card-text>
                </div>
              </v-card>
            </div>
          </v-col>
        </template>
        <!-- title_subtitle -->
        <template v-if="section.acf_fc_layout === 'title_subtitle'">
          <v-col cols="12" sm="12" md="10" xl="6">
            <h2 class="text-center title" v-html="section.title" />
            <v-row class="ma-0" justify="center">
              <div class="separator" />
            </v-row>
            <p class="mb-8" v-html="section.subtitle" />
          </v-col>
        </template>
        <!-- images_block -->
        <template v-if="section.acf_fc_layout === 'images_block'">
          <v-col cols="12">
            <v-parallax
              :src="section.imagem_de_destaque_desk.url"
              height="800"
              :class="$vuetify.breakpoint.mobile ? 'd-none desk' : 'desk'"
              :alt="section.imagem_de_destaque_desk.title"
            ></v-parallax>
            <v-parallax
              :src="section.imagem_de_destaque_mob.url"
              height="400"
              :class="!$vuetify.breakpoint.mobile ? 'd-none mobile' : 'mobile'"
              :alt="section.imagem_de_destaque_mob.title"
            ></v-parallax>
          </v-col>
        </template>
        <!-- slider_block -->
        <template v-if="section.acf_fc_layout === 'slider_block'">
          <v-col cols="12" sm="12" md="10" xl="8">
            <v-carousel hide-delimiters cycle height="auto">
              <v-carousel-item v-for="(slide, k) in section.slider" :key="k">
                <v-row class="fill-height" align="center" justify="center">
                  <v-col cols="12" sm="12" md="6" lg="5">
                    <img
                      :src="
                        slide.photo
                          ? slide.photo.sizes['thumb-slider-testimonial']
                          : slide.photo.url
                      "
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="7">
                    <h3 class="text-h5 mb-8">{{ slide.title }}</h3>
                    <div v-html="slide.texto" />
                  </v-col>
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </template>
      </v-row>
    </highlight-container>
  </div>
</template>

<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import WordPressProvider from '@/providers/WordPressProvider';

export default {
  name: 'WorkWithUs',
  metaInfo: {
    title: 'Trabalhe Conosco',
  },
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
  },
  data: () => ({
    settingsSlide: {
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      speed: 300,
      swipe: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1,
            arrows: true,
            swipe: true,
          },
        },
      ],
    },
    pageData: null,
    heroSectionBackground: null,
    jobCategory: null,
  }),
  computed: {
    heroSection() {
      if (this.pageData && this.pageData.acf.hero_section) {
        this.getHeroSectionBackground(this.pageData.acf.hero_section);
        return this.pageData.acf.hero_section;
      }
      return null;
    },
    jobVacancies() {
      if (this.jobCategory) {
        if (this.pageData && this.pageData.acf.job_vacancies) {
          return this.pageData.acf.job_vacancies.filter(vacancy => {
            return vacancy.tags.find(tag => tag.value === this.jobCategory);
          });
        }
        return null;
      }
      return this.pageData && this.pageData.acf.job_vacancies
        ? this.pageData.acf.job_vacancies
        : '';
    },
    jobVacanciesTags() {
      const tags = [];
      if (this.pageData && this.pageData.acf.job_vacancies) {
        this.pageData.acf.job_vacancies.forEach(vacancy => {
          if (vacancy.tags.length > 0) {
            tags.push(
              vacancy.tags.reduce((acc, cur, i) => {
                i -= 1;
                if (
                  acc.value !== cur.value &&
                  tags[i] &&
                  tags[i].value !== cur.value
                ) {
                  return cur;
                }
                return acc;
              }),
            );
          }
        });
        return tags;
      }
      return [];
    },
    pipefyLink() {
      if (this.pageData && this.pageData.acf.pipefy_link) {
        return this.pageData.acf.pipefy_link;
      }
      return null;
    },
    commonText() {
      if (this.pageData && this.pageData.acf.common_text) {
        return this.pageData.acf.common_text;
      }
      return null;
    },
    repeaterSections() {
      if (this.pageData && this.pageData.acf.sections) {
        return this.pageData.acf.sections;
      }
      return null;
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      const promise = await WordPressProvider.getPageBySlug('trabalhe-conosco');
      if (promise && promise.data.length > 0) {
        /* eslint-disable prefer-destructuring */
        this.pageData = promise.data[0];
      }
    },
    goToVacancy(e) {
      this.$router.push({
        name: 'vacancy',
        params: {
          slug: e.replace(/[^A-Z0-9]+/gi, '-').toLowerCase(),
        },
      });
    },
    filterVacanciesList(e) {
      this.jobCategory = e;
    },
    getHeroSectionBackground(data) {
      this.heroSectionBackground = `background-image: url(${data.bg_image.url})`;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.background-img
  background-position: center top
.hero-section-wrapper
  background-size: cover
  background-position: center center
  background-repeat: no-repeat
  position: relative
  height: 600px
  &:before
    content: ""
    background-color: rgba(0,0,0,.4)
    position: absolute
    display: block
    width: 100%
    height: 100%
    top: 0
    left: 0
    z-index: 1
  h1, h2
    z-index: 2
    color: #ffffff
  h1
    font-size: 3em !important
    padding: 0 15% 40px
    line-height: 1.3em !important
    text-align: center !important
    font-weight: 500
    letter-spacing: 0.0125em !important
    font-family: $body-font-family !important
    @media screen and (max-width: $sm)
      line-height: 1.3em !important
      font-size: 2.5em !important
      padding: 0 10% 0 10%
    @media screen and (max-width: $xs)
      font-size: 1.8em !important
      padding: 0 0 20px 0
  h2
    font-size: 1.3rem
    font-weight: 300
    line-height: 1.1
.why_work_with_us,
.title_subtitle,
.images_block,
.slider_block
  .title
    font-size: 2em !important
    padding: 0 15%
    line-height: 1.3em !important
  .separator
    margin: 20px 0 30px 0
    height: 3px
    width: 12%
    background-color: #01ee55
    @media screen and (max-width: $sm)
      height: 3.5px
      width: 25%
    @media screen and (max-width: $xs)
      width: 40%
.slider_block
  min-height: 510px
.job-vacancies-list-wrapper
  list-style-type: none
  padding: 0
  margin: 0
  li
    background-color: transparent
    padding: 7px 15px
    transition: all 0.3s ease-in-out
    &:not(:last-child)
      border-bottom: 1px solid #eee
    &:hover
      background-color: #FAFAFA
      transition: all 0.3s ease-in-out
    a
      position: relative
      display: flex
      flex-wrap: wrap
      justify-content: flex-start
      align-items: center
      outline: none
      text-decoration: none
.benefits-list-wrapper
  .v-card
    display: flex
    flex-direction: column
    box-shadow: none !important
    .item-content
      position: relative
      display: block
      height: 100%
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)
      .v-card__title
        word-break: break-word
        color: #3DCF8E
.slider_block
  .v-carousel
    .v-window-item
      h3
        color: #3DCF8E
      div
        color: #59595c
        img
          max-width: 100%

.new-color
  .hero-section-wrapper
    &:before
      background-color: rgba(0,48,54,.4)
    h1, h2
      font-family: 'metropolismedium' !important
      font-weight: normal !important
  .why_work_with_us .title
    font-family: 'metropolismedium' !important
    font-weight: normal !important
  .why_work_with_us,
  .title_subtitle,
  .images_block,
  .slider_block,
  .job-vacancies-list-wrapper li a,
  .job-vacancies-list-wrapper li a span,
  .v-application .text-subtitle-1
    font-family: 'metropolisregular' !important
    font-weight: normal !important
    .separator
      background-color: #26d07c
  .slider_block
    .v-carousel
      .v-window-item
        div
          color: #003036
  .v-input,
  .v-menu__content .v-select-list
    font-family: 'metropolisregular' !important
    font-weight: normal !important
  .job-vacancies-list-wrapper li:hover
    background-color: rgba(0, 48,54, .1)
  .v-chip
    background: rgba(0, 48,54,.6) !important
    color: #fff
  .title_subtitle .title
    font-family: 'metropolismedium' !important
    font-weight: normal !important
    font-size: 32px !important
    color: #003036
  .title_subtitle p
    font-size: 19px !important
  .benefits-list-wrapper .v-card .item-content .v-card__title
    font-family: 'metropolismedium' !important
    font-weight: normal !important
    color: #26d07c
  .v-application .text-subtitle-1,
  .why_work_with_us .title,
  .why_work_with_us p
    color: #003036
  .why_work_with_us p,
  .v-application .text-subtitle-1
    font-size: 19px !important
  .slider_block
    .v-carousel
      .v-window-item
        h3
          font-family: 'metropolismedium' !important
          font-weight: normal !important
          color: #26d07c
          font-size: 32px !important
        div
          font-family: 'metropolisregular' !important
          font-weight: normal !important
          color: #003036
          font-size: 19px !important
</style>
